import {ToastProps, ToastVariant, ToastHeader} from 'src/components/Toast/index'

export interface ToastType extends ToastProps {
  id: string,
  variant: ToastVariant,
  header: ToastHeader,
  message: string,
  delay?: number,
}

const defaultToastState = {
  toasts: [] as ToastType[],
}

export type ToastStateType = typeof defaultToastState

export default defaultToastState
